// extracted by mini-css-extract-plugin
export default {"columna":"CargaLibroContableForm_columna__F918Z","buttons":"CargaLibroContableForm_buttons__kS-6h","text":"CargaLibroContableForm_text__Cgwca"};